// User Data Transformer
// Maps API user data format to app user format

/**
 * Transform API user response to app user format
 * @param {object} apiUser - User data from API
 * @returns {object} Transformed user object
 */
export const transformUser = (apiUser) => {
  if (!apiUser) return null;

  // Map user_status to isApproved
  // APPROVED -> true, NOT APPROVED -> false
  const isApproved = apiUser.user_status === 'APPROVED';

  return {
    id: apiUser.user_id?.toString() || null,
    user_id: apiUser.user_id, // Keep original for API calls
    name: apiUser.name || '',
    email: apiUser.email || '',
    phone: apiUser.phone_number || '',
    phone_number: apiUser.phone_number, // Keep original for API calls
    image: apiUser.photo || null,
    photo: apiUser.photo, // Keep original for API calls
    userType: apiUser.user_type || 'USER',
    user_type: apiUser.user_type, // Keep original for API calls
    userStatus: apiUser.user_status || 'ACTIVE',
    user_status: apiUser.user_status, // Keep original for API calls
    isApproved: isApproved,
    email_verified_at: apiUser.email_verified_at || null,
    created_at: apiUser.created_at || null,
    updated_at: apiUser.updated_at || null,
  };
};

/**
 * Transform app user format to API user format for updates
 * @param {object} appUser - User data in app format
 * @returns {object} Transformed user object for API
 */
export const transformUserForAPI = (appUser) => {
  if (!appUser) return null;

  const apiUser = {};

  // Only include fields that can be updated
  if (appUser.name !== undefined) apiUser.name = appUser.name;
  if (appUser.email !== undefined) apiUser.email = appUser.email;
  if (appUser.phone !== undefined || appUser.phone_number !== undefined) {
    apiUser.phone_number = appUser.phone_number || appUser.phone;
  }
  if (appUser.photo !== undefined || appUser.image !== undefined) {
    apiUser.photo = appUser.photo || appUser.image;
  }
  if (appUser.password !== undefined) apiUser.password = appUser.password;
  if (appUser.user_type !== undefined) apiUser.user_type = appUser.user_type;
  if (appUser.user_status !== undefined) apiUser.user_status = appUser.user_status;

  return apiUser;
};

